export const VIEW_TABLE = 0;
export const VIEW_GRID = 1;
export const SORT_123 = 0;
export const SORT_ABC = 1;
export const PASSTHORUGH_ENV = "development";
export const filterableTaxonomiesDatas = [
  {
    label: "Service",
    value: "service"
  },
  {
    label: "Client Industry",
    value: "industry"
  },
  {
    label: "Subject Matter",
    value: "subject-matter"
  },
  {
    label: "Tech Stack",
    value: "technology"
  },
  {
    label: "Tag",
    value: "post_tag"
  }
];
